export default __webpack_public_path__ + "static/media/shayan-black.df0314af.svg";